import { createAction, props } from '@ngrx/store';
import { EMeetingActions, IMeeting } from '../models/meeting.model';

export const viewMeeting = createAction(
  EMeetingActions.VIEW_MEETING,
  props<{ id_meeting: number }>(),
);

export const refreshMeeting = createAction(
  EMeetingActions.REFRESH_MEETING,
  props<{ id_meeting: number }>(),
);

export const viewMeetingSuccess = createAction(
  EMeetingActions.VIEW_MEETING_SUCCESS,
  props<{ data: IMeeting[] }>(),
);

export const viewMeetingError = createAction(
  EMeetingActions.VIEW_MEETING_ERROR,
  props<{ error: any }>(),
);

export const updateMeeting = createAction(
  EMeetingActions.UPDATE_MEETING,
  props<{ meeting: IMeeting }>(),
);

export const updateMeetingSuccess = createAction(
  EMeetingActions.UPDATE_MEETING_SUCCESS,
  props<{ response: any }>(),
);

export const updateMeetingError = createAction(
  EMeetingActions.UPDATE_MEETING_ERROR,
  props<{ error: any }>(),
);

export const deleteMeeting = createAction(
  EMeetingActions.DELETE_MEETING,
  props<{ id_meeting: number }>(),
);

export const deleteMeetingSuccess = createAction(
  EMeetingActions.DELETE_MEETING_SUCCESS,
  props<{ response: any }>(),
);

export const deleteMeetingError = createAction(
  EMeetingActions.DELETE_MEETING_ERROR,
  props<{ error: any }>(),
);

export const restoreMeeting = createAction(
  EMeetingActions.RESTORE_MEETING,
  props<{ id_meeting: number }>(),
);

export const restoreMeetingSuccess = createAction(
  EMeetingActions.RESTORE_MEETING_SUCCESS,
  props<{ response: any }>(),
);

export const restoreMeetingError = createAction(
  EMeetingActions.RESTORE_MEETING_ERROR,
  props<{ error: any }>(),
);

export const addAProduct = createAction(
  EMeetingActions.ADD_A_PRODUCT,
  props<{ meeting: IMeeting; product: any }>(),
);

export const addAProductSuccess = createAction(
  EMeetingActions.ADD_A_PRODUCT_SUCCESS,
  props<{ response: any }>(),
);

export const addAProductError = createAction(
  EMeetingActions.ADD_A_PRODUCT_ERROR,
  props<{ error: any }>(),
);

export const updateAProduct = createAction(
  EMeetingActions.UPDATE_A_PRODUCT,
  props<{ meeting: IMeeting; product: any }>(),
);

export const updateAProductSuccess = createAction(
  EMeetingActions.UPDATE_A_PRODUCT_SUCCESS,
  props<{ id_meeting: number }>(),
);

export const updateAProductError = createAction(
  EMeetingActions.UPDATE_A_PRODUCT_ERROR,
  props<{ error: any }>(),
);

export const deleteAProduct = createAction(
  EMeetingActions.DELETE_A_PRODUCT,
  props<{ meeting: IMeeting; product: any }>(),
);

export const deleteAProductSuccess = createAction(
  EMeetingActions.DELETE_A_PRODUCT_SUCCESS,
  props<{ response: any }>(),
);

export const deleteAProductError = createAction(
  EMeetingActions.DELETE_A_PRODUCT_ERROR,
  props<{ error: any }>(),
);

export const updateLeftMenuCount = createAction(
  EMeetingActions.UPDTATE_LEFT_MENU_COUNT,
  props<{ data: {} }>(),
);

export const updateLeftMenuCountSuccess = createAction(
  EMeetingActions.UPDTATE_LEFT_MENU_COUNT_SUCCESS,
  props<{ response: any }>(),
);

export const updateLeftMenuCountError = createAction(
  EMeetingActions.UPDTATE_LEFT_MENU_COUNT_ERROR,
  props<{ error: any }>(),
);
